export default __webpack_public_path__ + "Src/Client/Localization/localizationSwitcher.html";